import types from '../constants';

const initialState = {
  isOpen: true
};

export default function liveNotification(state = initialState, action) {
  switch (action.type) {
  case types.SET_NOTIF_STATUS:
    return {
      ...state,
      ...action.payload
    };
  default:
    return { ...state };
  }
}
